import { AppMenuDto, CrudAction } from './app.model';

export const integrationMenus = [
  {
    path: 'veson',
    entity: 'vesonROE',
    iconClass: 'stock',
    requiredPolicy: 'Integrations.Veson',
    crudAction: {
      create: CrudAction.hidden,
      update: CrudAction.hidden,
      delete: CrudAction.hidden,
    },
  },
  {
    path: 'cbtroe',
    entity: 'turkishROE',
    iconClass: 'stock',
    requiredPolicy: 'Integrations.CBT',
    crudAction: {
      create: CrudAction.hidden,
      update: CrudAction.hidden,
      delete: CrudAction.hidden,
    },
  },
  {
    path: 'd365',
    entity: 'd365TransactionHeader',
    iconClass: 'reconciliation',
    requiredPolicy: 'D365.D365TransactionHeaders',
    // crudAction: {
    //   create: CrudAction.hidden,
    //   update: CrudAction.hidden,
    //   delete: CrudAction.hidden,
    // },
  },
  {
    path: 'd365-accruals',
    entity: 'd365TransactionLine',
    requiredPolicy: 'D365.D365TransactionLines',
    iconClass: 'one-to-one',
    // crudAction: {
    //   create: CrudAction.hidden,
    //   update: CrudAction.hidden,
    //   delete: CrudAction.hidden,
    // },
  },
  {
    path: 'alaan-transaction-log',
    entity: 'alaanTransactionLog',
    requiredPolicy: 'Integrations.AlaanTransactionLogs',
    iconClass: 'credit-card',
    crudAction: {
      create: CrudAction.hidden,
      /*update: CrudAction.hidden,
      delete: CrudAction.hidden,*/
    },
  },
] as AppMenuDto[];
